import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import {
  DriveContentState,
  DriveFileActionEvent,
  DriveFileCard,
  DriveFolderActionEvent,
  DriveFolderCard,
  DriveSelectionToolbarEvent,
  DriveTreeNode,
  SyllabusTreeNode,
} from './drive.types';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-resource-drive-view',
    templateUrl: './drive-view.component.html',
    styleUrls: ['./drive-view.component.scss'],
    standalone: false,
})
export class ResourceDriveViewComponent {
  @Input() treeNodes: DriveTreeNode[] = [];
  @Input() expandedKeys: string[] = [];
  @Input() selectedKeys: string[] = [];
  @Input() sidebarError: string | null = null;
  @Input() sidebarLoading = false;

  @Input() contentState: DriveContentState = 'loading';
  @Input() searchKeyword = '';
  @Input() isDriveSearch = false;
  @Input() folderCards: DriveFolderCard[] = [];
  @Input() fileCards: DriveFileCard[] = [];
  @Input() sortableFileCards: DriveFileCard[] = [];
  @Input() otherFileCards: DriveFileCard[] = [];
  @Input() canSortFiles = false;
  @Input() breadcrumb: { id: number; name: string }[] = [];
  @Input() filesLoadError: string | null = null;
  @Input() totalNum = 0;
  @Input() pageIndex = 1;
  @Input() pageSize = 10;
  @Input() resourceType = '';
  @Input() showCopyAction = false;
  @Input() currentFolderId: number | null = null;
  @Input() selectionResetToken = 0;
  @Input() hasClipboard = false;
  @Input() canPaste = false;

  @Output() folderSelect = new EventEmitter<{ pathIds: number[]; node: SyllabusTreeNode | null }>();
  @Output() expandedKeysChange = new EventEmitter<string[]>();
  @Output() folderOpen = new EventEmitter<number[]>();
  @Output() breadcrumbNavigate = new EventEmitter<number>();
  @Output() retryCategory = new EventEmitter<void>();
  @Output() pageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();
  @Output() fileOpen = new EventEmitter<number>();
  @Output() fileAction = new EventEmitter<DriveFileActionEvent>();
  @Output() folderAction = new EventEmitter<DriveFolderActionEvent>();
  @Output() folderSort = new EventEmitter<CdkDragDrop<DriveFolderCard[]>>();
  @Output() fileSort = new EventEmitter<CdkDragDrop<DriveFileCard[]>>();
  @Output() retryFiles = new EventEmitter<void>();
  @Output() selectionToolbarAction = new EventEmitter<DriveSelectionToolbarEvent>();

  sidebarCollapsed = false;

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }
}
